export enum DefaultPredefinedRangeValue {
  Last7Days = '7',
  Last30Days = '30',
  Last90Days = '90',
  Last365Days = '365',
  MonthToDate = 'mtd',
  PreviousMonth = 'pm',
  YearToDate = 'ytd',
  Custom = 'custom',
}

export const DEFAULT_PREDEFINED_RANGES = [
  {
    value: DefaultPredefinedRangeValue.Last7Days,
    label: 'Last 7 Days',
  },
  {
    value: DefaultPredefinedRangeValue.Last30Days,
    label: 'Last 30 Days',
  },
  {
    value: DefaultPredefinedRangeValue.Last90Days,
    label: 'Last 90 Days',
  },
  {
    value: DefaultPredefinedRangeValue.Last365Days,
    label: 'Last 365 Days',
  },
  {
    value: DefaultPredefinedRangeValue.MonthToDate,
    label: 'This Month to Date',
  },
  {
    value: DefaultPredefinedRangeValue.PreviousMonth,
    label: 'Previous Month',
  },
  {
    value: DefaultPredefinedRangeValue.YearToDate,
    label: 'This Year to Date',
  },
  {
    value: DefaultPredefinedRangeValue.Custom,
    label: 'Custom',
  },
];

export type PredefinedRange = {
  value: string;
  label: string;
};

export const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
